export default __webpack_public_path__ + "static/media/branchIcon.49b65735.svg";